import React from "react";
import IssueCard from "./IssueCard";
import { withRouter } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    padding: "10px"
  },
});

const IssuesGrid = (props) => {
  const classes = useStyles();
  //console.log(props);
  //console.log(props.issues.issues);
  return (
    <div className={classes.root}>
      <Grid container spacing={2} >
        {props.issues && props.issues.map((issue, index) => (
          <Grid key={issue.id} item xs={12} sm={6} md={4}>
            <IssueCard
              setAlertOpen={props.setAlertOpen}
              issue={issue}
              index={index}
              customization={props.customization}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

function mapStateToProps(state) {
  //console.log("[IssueGrid]", state);
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssuesGrid));
